import {ValidationDoc} from "@buildwitt/use-validate";
import {IQuizEntityPayload} from "@buildwitt/shapeshift-types";

export const cohortQuizValidationDoc: ValidationDoc<IQuizEntityPayload> = {
	title: [{
		errorMessage: "required",
		validate: e => !!e.title
	}],
	scoreRequired: [{
		errorMessage: "required",
		validate: e => !!e.title
	}]
}

